@if (spinnerState() && spinnerState().show) {
  <app-spinner [state]="spinnerState()"></app-spinner>
}
<app-sidebar
  [config]="config()"
  class="fixed w-[209px] flex flex-col p-8 bg-white text-[#363636] h-screen"
></app-sidebar>
<main class="flex-1 ml-[209px] p-8">
  <div class="flex justify-between items-center flex-wrap mb-5">
    @if (pageTitle()) {
      <app-headline
        [content]="{
          title: pageTitle(),
          hTag: hTag.H1,
          headlineAlignment: alignment.Left,
        }"
        [showDivider]="true"
        [showDoubleDivider]="true"
      ></app-headline>
    }

    <app-button
      (clickedEvent)="signOut()"
      text="Déconnexion"
      variation="tertiary"
    >
    </app-button>
  </div>
  <router-outlet />
</main>

@if (hasTechnicalError() && !inlineTechnicalError()) {
  <app-dialog>
    <ng-container dialog-content>
      <app-headline
        class="block mb-6"
        [content]="{
          title: 'Le site est momentanément indisponible.',
          hTag: hTag.H2,
          headlineAlignment: alignment.Center,
          id: 'number-of-journeys-headline',
        }"
        [showDivider]="true"
      ></app-headline>
      <p class="text-center text-sm">
        Veuillez <strong>rafraichir</strong> la page ou
        <strong>réessayer</strong> ultérieurement.
      </p>
    </ng-container>
    <ng-container dialog-footer>
      <div class="flex items-center mt-6 justify-center">
        <button
          class="cursor-pointer border border-[#000] rounded-lg font-semibold p-4 hover:bg-[#F3F3F3] transition-colors duration-200"
          (click)="refreshPage()"
        >
          Rafraichir
        </button>
      </div>
    </ng-container>
  </app-dialog>
}

@if (sessionExpired()) {
  <app-dialog>
    <ng-container dialog-content>
      <app-headline
        class="block mb-6"
        [content]="{
          title: 'Votre session a expiré',
          hTag: hTag.H2,
          headlineAlignment: alignment.Center,
        }"
        [showDivider]="true"
      ></app-headline>
      <p class="text-center text-sm mb-6">
        Veuillez vous reconnecter pour commencer un parcours.
      </p>
    </ng-container>
    <ng-container dialog-footer>
      <div class="flex items-center mt-6 justify-center">
        <app-button
          (clickedEvent)="handleReconnect()"
          text="Me connecter"
          variation="tertiary"
        >
        </app-button>
      </div>
    </ng-container>
  </app-dialog>
}
